export default __webpack_public_path__ + "static/media/image4.76472077.svg";